import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'
import { initializeAnalytics } from './utils/analytics.ts'
import './styles/index.css'

// Initialize Google Analytics
initializeAnalytics();

// Suppress source map warnings in development
if (import.meta.env.DEV) {
  const originalError = console.error;
  console.error = (...args) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('Source map error')) {
      return; // Suppress source map warnings
    }
    originalError.call(console, ...args);
  };
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
